import { z } from 'zod';

import { NavColumn } from './nav-column';

export const NavMenuColumn = z.object({
  view_all_link: z.nullable(z.string()),
  column: z.array(NavColumn),
});

export type NavMenuColumn = z.infer<typeof NavMenuColumn>;
